import React from "react";
import styled from "styled-components";
import { StatusIndicator, Text, DropDown } from "@flexisaf/flexibull2";
import Theme, { Colors } from "../theme";

const CardContainer = styled.div`
  background: #f1f1f17d;

  & .card-header {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    font-weight: 500;
    & img {
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
    & .exam-title {
      p:first-of-type {
        font-size: 1rem;
      }
    }
  }
  & .content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    & .tag {
      width: min-content;
      margin: 0 auto;
    }
    & .card-body {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      color: ${Colors.Grey700};

      padding: 1rem 0;

      & p > span {
        font-weight: 700;
        color: ${Colors.Grey700};
      }
    }
    & .card-footer {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2rem;
      color: ${Colors.Grey700};
    }
  }
`;

export const PaperCardList = ({
  handleRedirect,
  handleEdit,
  handleDelete,
  paperData,
  questionCount,
}) => {
  const { name, subjectName } = paperData;
  return (
    <CardContainer>
      <div className="card-header">
        <Text color={Colors.Grey700}>
          <i
            className="saf-stickynote"
            style={{ marginRight: "5px", color: `${Theme.PrimaryColor}` }}
          />
          {name}
        </Text>
        <DropDown
          label={
            <Text bold size="14px" style={{ cursor: "pointer" }}>
              ...
            </Text>
          }
          menuAlign="bottom right"
          trigger="click"
          menuList={[
            {
              onClick: () => handleEdit(),
              label: "Edit Paper",
              iconLeft: "saf-receipt-edit",
            },
            {
              onClick: () => handleDelete(),
              label: "Delete Paper",
              color: Theme.PrimaryRed,
              iconLeft: "saf-trash",
            },
          ]}
        />
      </div>
      <div
        style={{ cursor: "pointer" }}
        onClick={handleRedirect}
        className="content-wrapper"
      >
        <div className="tag">
          <StatusIndicator
            compound
            label={paperData?.isActive ? "Active" : "Inactive"}
            color={paperData?.isActive ? Theme.PrimaryGreen : Theme.PrimaryRed}
          />
        </div>

        <div className="card-body">
          {subjectName && (
            <p>
              <span>Subject:</span> {subjectName}
            </p>
          )}
        </div>

        <div className="card-footer">
          <p>
            {paperData.questionCount || 0} Question
            {paperData.questionCount !== 1 && "s"}
          </p>
        </div>
      </div>
    </CardContainer>
  );
};
